// Chat.js
import React, { useState, useEffect, useRef } from "react";
import io from "socket.io-client";
import "./chat.scss";

const SOCKET_URL = "https://coolseraback.onrender.com";

function Chat({ roomname }) {
  const [messages, setMessages] = useState([]);
  const [socket, setSocket] = useState(null);
  const messagesEndRef = useRef(null);

  // Inicialización del socket y conexión a la sala
  useEffect(() => {
    const newSocket = io(SOCKET_URL, {
      transports: ["websocket"],
      withCredentials: true,
    });
    setSocket(newSocket);

    // Emitimos el evento para unirse a la sala
    newSocket.emit("joinRoom", { roomname });

    // Escuchamos los mensajes del servidor
    newSocket.on("message", (data) => {
      setMessages((prevMessages) => [...prevMessages, data]);
    });

    // Cleanup al desmontar el componente
    return () => {
      newSocket.disconnect();
    };
  }, [roomname]);

  // Manejo de efectos visuales al recibir mensajes
  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1];

      if (lastMessage.effectActive) {
        updateStrobeEffect(lastMessage);
      } else if (document.getElementById(lastMessage.room)) {
        const roomElement = document.getElementById(lastMessage.room);
        roomElement.style.animation = "none";
        roomElement.style.backgroundColor = lastMessage.colors[0];
      }
    }
  }, [messages]);

  // Función para crear el efecto estroboscópico
  const updateStrobeEffect = (lastMessage) => {
    const beatsPerMeasure =
      lastMessage.timeSignature === "3/4"
        ? 3
        : lastMessage.timeSignature === "6/8"
        ? 6
        : 4;
    const duration = (60 / lastMessage.bpm) * beatsPerMeasure;

    // Construimos keyframes dinámicamente
    let keyframes = "@keyframes strobe {";

    if (lastMessage.colors.length === 1) {
      // Alternar entre el único color y blanco
      keyframes += `
        0% { background-color: ${lastMessage.colors[0]}; } 
        50% { background-color: white; } 
        100% { background-color: ${lastMessage.colors[0]}; }
      `;
    } else {
      // Alternar entre múltiples colores
      const step = 100 / lastMessage.colors.length;
      lastMessage.colors.forEach((color, index) => {
        keyframes += `${index * step}% { background-color: ${color}; }`;
      });
      keyframes += `100% { background-color: ${lastMessage.colors[0]}; }`;
    }

    keyframes += "}";

    // Agregar los keyframes al primer stylesheet disponible
    const styleSheet = document.styleSheets[0];
    if (styleSheet.cssRules.length > 0) {
      styleSheet.deleteRule(0);
    }
    styleSheet.insertRule(keyframes, 0);

    // Aplicar la animación al elemento de la sala
    const roomElement = document.getElementById(lastMessage.room);
    if (roomElement) {
      roomElement.style.animation = `strobe ${duration}s infinite`;
    }
  };

  return (
    <div className="chat" id={roomname}>
      {/* Referencia para desplazamiento automático (opcional) */}
      <div ref={messagesEndRef} />
    </div>
  );
}

export default Chat;
